import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { GallerySection } from "@/components/GallerySection";
import { TuningCalculator } from "@/components/TuningCalculator";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { ContactSection } from "@/components/ContactSection";

const Index = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <AboutSection />
      <GallerySection />
      <TuningCalculator />
      <TestimonialsSection />
      <ContactSection />
    </div>
  );
};

export default Index;